export const STEPS = [
  { label: "Plan Details", value: "Details" },
  { label: "Add Areas", value: "Areas" },
  { label: "Add Options", value: "Options" },
];
